import React, { Component } from 'react';

import Form from '../../Form';
import FilterType from '../FilterType';

import './styles.css';

class FilterWrapper extends Component {
  state = {
    value:
      this.props.type === 'paginatedSelect' ||
      this.props.type === 'period' ||
      this.props.type === 'multiselect'
        ? this.props.currentValue
        : '',
  };

  _submitFilter = () => {
    this.props.onFilter(this.state.value);
  };

  render() {
    const {
      type,
      options,
      placeholder,
      hasNextPage,
      isNextPageLoading,
      loadNextPage,
      renderLeft,
      searchTerm,
      identifier,
      onSearchByTerm,
      noMinWidth,
      scrollAuto,
      isFetching,
      itemSize,
      totalOptions,
      customComponent,
      customComponentProps,
      customStyles,
    } = this.props;
    const { value } = this.state;

    return (
      <Form
        customStyles={{
          minWidth: noMinWidth ? 'auto' : '',
          scrollY: scrollAuto ? 'auto' : 'scroll',
          ...customStyles,
        }}
        className={
          type === 'paginatedSelect'
            ? 'FilterWrapper FilterWrapper__big'
            : 'FilterWrapper'
        }
        actionBarClassName="FilterWrapper__action-bar"
        submitText="Aplicar"
        onSubmit={() => this._submitFilter()}
      >
        <FilterType
          identifier={identifier}
          hasNextPage={hasNextPage}
          isNextPageLoading={isNextPageLoading}
          loadNextPage={loadNextPage}
          type={type}
          options={options}
          placeholder={placeholder}
          value={value}
          renderLeft={renderLeft}
          onChange={newValue => this.setState({ value: newValue })}
          searchTerm={searchTerm}
          onSearchByTerm={onSearchByTerm}
          isFetching={isFetching}
          itemSize={itemSize}
          totalOptions={totalOptions}
          customComponent={customComponent}
          customComponentProps={customComponentProps}
        />
      </Form>
    );
  }
}

export default FilterWrapper;
